import axios from "axios";
import { API_URL, ID_APP, PUBLIC_TOKEN } from "./constants";
import { generateSearchKeywords } from "./helpers";

type asyncPublicRequestType = {
  method?: "get" | "put" | "put" | "delete";
  endpoint?: string;
  withIdApp?: boolean;
  searchObj?: { [key: string]: any };
  data: any;
};
const asyncPublicRequest = async ({
  method = "get",
  endpoint,
  withIdApp = true,
  searchObj,
  data,
}: asyncPublicRequestType) => {
  const queryString = generateSearchKeywords(searchObj || {});

  const url = `${API_URL}${withIdApp ? `/${withIdApp ? ID_APP : ""}` : ""}${
    endpoint || ""
  }${queryString}${`${!!queryString ? "&" : "?"}access_token=${PUBLIC_TOKEN}`}`;

  const resp = await axios[method](url, data);
  return resp;
};

// get list
type asyncGetListType = {
  apiCode: string;
  withIdApp?: boolean;
  idApp?: string;
  condition?: { [key: string]: any };
  applyToken?: boolean;
  token: string;
  stringifyData?: boolean;
  extraPath?: string;
};
const asyncGetList = async ({
  apiCode = "dmnvt",
  withIdApp = true,
  idApp,
  condition = {},
  applyToken = true,
  token,
  stringifyData = true,
  extraPath = "",
}: asyncGetListType) => {
  try {
    const queryString = generateSearchKeywords(condition, stringifyData);
    const url = `${API_URL}${
      withIdApp ? `/${withIdApp ? idApp || ID_APP : ""}` : ""
    }${`/${apiCode || ""}`}${extraPath}${queryString}${
      applyToken
        ? `${`${!!queryString ? "&" : "?"}access_token=${
            token || PUBLIC_TOKEN
          }`}`
        : ""
    }`;

    const resp = await axios.get(url);
    if (resp.status === 200) {
      return resp;
    }
  } catch (error: any) {
    return error.response;
  }
};

// search list
type asyncSearchListType = {
  apiCode: string;
  withIdApp?: boolean;
  idApp?: string;
  condition?: { [key: string]: any };
  query?: { [key: string]: any };
  applyToken?: boolean;
  token?: string;
};
const asyncSearchList = async ({
  apiCode,
  withIdApp = true,
  idApp,
  condition = {},
  query = {},
  applyToken = true,
  token,
}: asyncSearchListType) => {
  try {
    let url = `${API_URL}/search`;
    const queryString = generateSearchKeywords(query);
    if (withIdApp) {
      url += `/${idApp || ID_APP}`;
    }
    if (apiCode) {
      url += `/${apiCode}`;
    }
    if (queryString) {
      url += queryString;
    }
    if (applyToken) {
      url += `${!!queryString ? "&" : "?"}access_token=${
        token || PUBLIC_TOKEN
      }`;
    }
    const resp = await axios.post(url, condition);
    return resp;
  } catch (error: any) {
    return error.response;
  }
};

// get item
type asyncGetType = {
  apiCode: string;
  id: string;
  withIdApp?: boolean;
  applyToken?: boolean;
  token?: string;
};
const asyncGet = async ({
  apiCode = "dmnvt",
  withIdApp = true,
  applyToken = true,
  token,
  id,
}: asyncGetType) => {
  try {
    const url = `${API_URL}${
      withIdApp ? `/${withIdApp ? ID_APP : ""}` : ""
    }${`/${apiCode || ""}`}/${id || ""}${
      applyToken ? `?access_token=${token || PUBLIC_TOKEN}` : ""
    }`;

    const resp = await axios.get(url);
    if (resp.status === 200) {
      return resp;
    }
  } catch (error: any) {
    return error.response;
  }
};

// post data
type asyncPostDataType = {
  apiCode: string;
  withIdApp?: boolean;
  data?: any;
  applyToken?: boolean;
  token?: string;
  extraUrl?: string;
  condition?: { [key: string]: any };
  stringifyData?: boolean;
};
const asyncPostData = async ({
  apiCode = "dmnvt",
  withIdApp = true,
  data = {},
  applyToken = true,
  token,
  extraUrl,
  condition = {},
  stringifyData = true,
}: asyncPostDataType) => {
  try {
    const queryString = generateSearchKeywords(condition, stringifyData);
    const url = `${API_URL}${
      withIdApp ? `/${withIdApp ? ID_APP : ""}` : ""
    }${`/${apiCode || ""}`}${extraUrl || ""}${queryString}${
      applyToken
        ? `${`${!!queryString ? "&" : "?"}access_token=${
            token || PUBLIC_TOKEN
          }`}`
        : ""
    }`;
    const resp = await axios.post(url, data);
    if (resp.status === 200) {
      return resp;
    }
  } catch (error: any) {
    return error.response;
  }
};

// put data
type asyncPutDataType = {
  apiCode: string;
  id: string;
  withIdApp?: boolean;
  data: any;
  applyToken?: boolean;
  token?: string;
};
const asyncPutData = async ({
  apiCode = "dmnvt",
  id,
  withIdApp = true,
  data = {},
  applyToken = true,
  token,
}: asyncPutDataType) => {
  try {
    const url = `${API_URL}${
      withIdApp ? `/${withIdApp ? ID_APP : ""}` : ""
    }${`/${apiCode || ""}/`}${id || ""}${
      applyToken ? `?access_token=${token || PUBLIC_TOKEN}` : ""
    }`;

    const resp = await axios.put(url, data);
    if (resp.status === 200) {
      return resp;
    }
  } catch (error: any) {
    return error.response;
  }
};

// delete
type asyncDeleteType = {
  apiCode: string;
  id: string;
  withIdApp?: boolean;
  applyToken?: boolean;
  token?: boolean;
};
const asyncDelete = async ({
  apiCode = "dmnvt",
  id,
  withIdApp = true,
  applyToken = true,
  token,
}: asyncDeleteType) => {
  try {
    const url = `${API_URL}${
      withIdApp ? `/${withIdApp ? ID_APP : ""}` : ""
    }${`/${apiCode || ""}/`}${id || ""}${
      applyToken ? `?access_token=${token || PUBLIC_TOKEN}` : ""
    }`;

    const resp = await axios.delete(url);
    if (resp.status === 200) {
      return resp;
    }
  } catch (error: any) {
    return error.response;
  }
};

export {
  asyncPublicRequest,
  asyncGet,
  asyncGetList,
  asyncSearchList,
  asyncPostData,
  asyncPutData,
  asyncDelete,
};
